var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2168 38.8353C12.2815 38.8353 16.3873 42.941 16.3873 48.0058C16.3873 42.941 20.493 38.8353 25.5578 38.8353C20.493 38.8353 16.3873 34.7295 16.3873 29.6648C16.3873 34.7295 12.2815 38.8353 7.2168 38.8353Z",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1436 31.9574C35.2083 31.9574 39.314 36.0631 39.314 41.1278C39.314 36.0631 43.4198 31.9574 48.4845 31.9574C43.4198 31.9574 39.314 27.8516 39.314 22.7869C39.314 27.8516 35.2083 31.9574 30.1436 31.9574V31.9574Z",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3877 15.909C21.4524 15.909 25.5582 20.0148 25.5582 25.0795C25.5582 20.0148 29.6639 15.909 34.7287 15.909C29.6639 15.909 25.5582 11.8032 25.5582 6.73853C25.5582 11.8032 21.4524 15.909 16.3877 15.909Z",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.1431188d.svg";
export { ForwardRef as ReactComponent };